import React from 'react'

const HistoryArrowsWhiteSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 21.981 24'
    >
      <g
        id='Group_1353'
        data-name='Group 1353'
        transform='translate(-324 -291)'
      >
        <path
          id='arrow-left-svgrepo-com_1_'
          data-name='arrow-left-svgrepo-com (1)'
          d='M7.685,7.332A1,1,0,0,0,6.271,5.918L1.6,10.583a2,2,0,0,0,0,2.828L6.273,18.08a1,1,0,0,0,1.414-1.414L4.022,13H22a1,1,0,0,0,0-2H4.017Z'
          transform='translate(322.98 285.375)'
          fill='#fff'
        />
        <path
          id='arrow-left-svgrepo-com_1_2'
          data-name='arrow-left-svgrepo-com (1)'
          d='M7.685,7.332A1,1,0,0,0,6.271,5.918L1.6,10.583a2,2,0,0,0,0,2.828L6.273,18.08a1,1,0,0,0,1.414-1.414L4.022,13H22a1,1,0,0,0,0-2H4.017Z'
          transform='translate(347 320.625) rotate(180)'
          fill='#fff'
        />
      </g>
    </svg>
  )
}

export default HistoryArrowsWhiteSvg
